import React, { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'

// Generic confirm. `requireText` forces the user to type that exact string
// before the confirm button enables (used for destructive actions).
const ConfirmDialog = ({
  open,
  title,
  children,
  confirmLabel = 'Confirm',
  confirmColor = 'primary',
  requireText,
  busy = false,
  error,
  onConfirm,
  onClose,
}) => {
  const [typed, setTyped] = useState('')
  useEffect(() => {
    if (open) setTyped('')
  }, [open])

  const blocked = busy || (requireText && typed !== requireText)

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack gap={2} paddingTop={1}>
          {children}
          {requireText && (
            <TextField
              value={typed}
              onChange={(event) => setTyped(event.target.value)}
              label={`Type "${requireText}" to confirm`}
              size="small"
              fullWidth
              autoComplete="off"
            />
          )}
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant="contained"
          disabled={blocked}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
